import React, { useState, useEffect, useRef } from 'react';
import { PDFDocument, rgb } from 'pdf-lib';
import './App.css';
import sauvieLogo from './sauvie_logo.png';
import locationPdfTemplate from './FORM_Contrat_de_location_2024.pdf';
import maintenancePdfTemplate from './FORM_Contrat_de_Maintenance.pdf';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';

function MainApp() {
  const { user, logout } = useAuth();
  const [locationFormData, setLocationFormData] = useState({
    client: { default: '', type: 'singleline_text', required: false, page: 0, section: '' },
    // reference_dossier: { default: '', type: 'singleline_text', required: false, page: 0, section: '' },
    numero_contrat: { default: '', type: 'singleline_text', required: false, page: 0, section: '', same_fields: ["reference_dossier", "numero_contrat_2", "numero_contrat_3"] },
    nom_raison_sociale: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE', same_fields: ["locataire"] },
    adresse: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE' },
    code_postal: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE' },
    ville: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE' },
    forme_juridique: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE' },
    siren: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE' },
    telephone: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE' },
    email: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONTRAT DE LOCATION - RENSEIGNEMENTS RELATIFS AU LOCATAIRE' },
    descriptif_equipement: { default: 'Défibrillateur  X1\nArmoire intérieure pour défibrillateur X1', type: 'multiline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - DESCRIPTIF DE L\'ÉQUIPEMENT', same_fields: ["descriptif_equipement_2"] },
    adresse_installation: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - DESCRIPTIF DE L\'ÉQUIPEMENT' },
    adresse_facturation: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - DESCRIPTIF DE L\'ÉQUIPEMENT' },
    fournisseur: { default: 'SAUVIE', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - DESCRIPTIF DE L\'ÉQUIPEMENT' },
    duree_location: { default: '60 mois', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - CONDITIONS FINANCIÈRES' },
    nombre_loyer: { default: '60', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - CONDITIONS FINANCIÈRES' },
    montant_ht_chaque_loyer: { default: '49€ HT', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - CONDITIONS FINANCIÈRES' },
    periodicite_loyers: { default: 'Mensuelle', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - CONDITIONS FINANCIÈRES' },
    fait_en_3_exemplaires_a: { default: 'Bron', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - CONDITIONS FINANCIÈRES', same_fields: ["fait_a"] },
    // fait_en_3_exemplaires_le: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - CONDITIONS FINANCIÈRES' },
    nom_locataire: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - Pour le locataire', same_fields: ["nom_locataire_2"] },
    qualite_du_signataire_locataire: { default: '', type: 'singleline_text', required: false, page: 1, section: 'CONDITIONS PARTICULIÈRES - Pour le locataire', same_fields: ["qualite_du_signataire_locataire_2"] },
    // descriptif_equipement_2: { default: '', type: 'multiline_text', required: false, page: 2, section: 'PROCÈS-VERBAL DE LIVRAISON ET DE CONFORMITÉ - DESCRIPTIF DE L\'ÉQUIPEMENT' },
    // locataire: { default: '', type: 'singleline_text', required: false, page: 2, section: 'PROCÈS-VERBAL DE LIVRAISON ET DE CONFORMITÉ - DESCRIPTIF DE L\'ÉQUIPEMENT' },
    lieu_installation: { default: '', type: 'singleline_text', required: false, page: 2, section: 'PROCÈS-VERBAL DE LIVRAISON ET DE CONFORMITÉ - DESCRIPTIF DE L\'ÉQUIPEMENT' },
    date: { default: '', type: 'singleline_text', required: false, page: 2, section: 'PROCÈS-VERBAL DE LIVRAISON ET DE CONFORMITÉ - DESCRIPTIF DE L\'ÉQUIPEMENT' },
    // nom_locataire_2: { default: '', type: 'singleline_text', required: false, page: 2, section: 'PROCÈS-VERBAL DE LIVRAISON ET DE CONFORMITÉ - Pour le locataire' },
    // qualite_du_signataire_locataire_2: { default: '', type: 'singleline_text', required: false, page: 2, section: 'PROCÈS-VERBAL DE LIVRAISON ET DE CONFORMITÉ - Pour le locataire' },
    // fait_a: { default: '', type: 'singleline_text', required: false, page: 2, section: 'PROCÈS-VERBAL DE LIVRAISON ET DE CONFORMITÉ - Pour le locataire' },
    reference_mandat: { default: 'SAU', type: 'singleline_text', required: false, page: 3, section: '' },
    debiteur_nom: { default: 'SAUVIE', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_siren: { default: '81928645', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_adresse_rue: { default: '8 RUE PASCAL', type: 'multiline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_adresse_code_postal: { default: '69500', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_adresse_ville: { default: 'BRON', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_telephone_fixe: { default: '0426648383', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_telephone_portable: { default: '', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_email: { default: '', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_iban: { default: '', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    debiteur_bic: { default: '', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    creancier_nom: { default: '', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    ics: { default: 'FR65ZZZ86425A', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    paiement_recurrent: { default: true, type: 'checkbox', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    paiement_ponctuel: { default: false, type: 'checkbox', required: false, page: 3, section: 'Mandat de prélèvement SEPA - COORDONNÉES DU DÉBITEUR' },
    signe_a: { default: 'BRON', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - SIGNATURE' },
    // signe_le: { default: '', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - SIGNATURE' },
    nom_qualite_signataire: { default: 'VELUIRE', type: 'singleline_text', required: false, page: 3, section: 'Mandat de prélèvement SEPA - SIGNATURE' }
  });
  const [maintenanceFormData, setMaintenanceFormData] = useState({
    souscripteur: { default: '', type: 'singleline_text', required: false, page: 0, section: 'DÉSIGNATION DES PARTIES', same_fields: ["signature_souscripteur_nom"] },
    souscripteur_adresse: { default: '', type: 'singleline_text', required: false, page: 0, section: 'DÉSIGNATION DES PARTIES' },
    represente_par: { default: '', type: 'singleline_text', required: false, page: 0, section: 'DÉSIGNATION DES PARTIES' },
    lot: { default: '1', type: 'singleline_text', required: false, page: 0, section: 'ÉTENDUE DU MARCHÉ' },
    adresse: { default: '', type: 'singleline_text', required: false, page: 0, section: 'ÉTENDUE DU MARCHÉ' },
    date_debut_contrat: { default: '', type: 'singleline_text', required: false, page: 0, section: 'DURÉE DU CONTRAT' },
    montant_ht: { default: '', type: 'singleline_text', required: false, page: 0, section: 'PRIX' },
    montant_ttc: { default: '', type: 'singleline_text', required: false, page: 0, section: 'PRIX' },
    fait_a: { default: 'Bron', type: 'singleline_text', required: false, page: 0, section: 'SIGNATURE' },
    // fait_le: { default: '', type: 'singleline_text', required: false, page: 0, section: 'SIGNATURE' },
    signature_souscripteur_fonction: { default: '', type: 'singleline_text', required: false, page: 0, section: 'SIGNATURE' },
  });
  const [lockFields, setLockFields] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [sections, setSections] = useState({});
  const [maintenanceSections, setMaintenanceSections] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [navigation, setNavigation] = useState('location');
  const textareaRefs = useRef({});

  useEffect(() => {
    // Organize fields by page and section
    const organizedSections = {};
    Object.entries(locationFormData).forEach(([fieldName, fieldData]) => {
      const { page = 0, section = 'Other' } = fieldData;
      if (!organizedSections[page]) {
        organizedSections[page] = {};
      }
      if (!organizedSections[page][section]) {
        organizedSections[page][section] = {};
      }
      organizedSections[page][section][fieldName] = fieldData;
    });
    setSections(organizedSections);
  }, [locationFormData]);

  useEffect(() => {
    // Initialize numero_contrat when user is logged in and on location navigation
    if (user && navigation === 'location') {
      const now = new Date();
      const formattedDate = `${String(now.getFullYear()).slice(-2)}${String(now.getMonth() + 1).padStart(2, '0')}`;

      setLocationFormData(prevData => ({
        ...prevData,
        numero_contrat: {
          ...prevData.numero_contrat,
          default: `SAU-${formattedDate}00`
        },
        reference_mandat: {
          ...prevData.reference_mandat,
          default: `SAU-${formattedDate}00`
        }
      }));

      // setLocationFormData(prevData => ({
      //   ...prevData,
      //   reference_mandat: {
      //     ...prevData.reference_mandat,
      //     default: `SAU-${formattedDate}00`
      //   }
      // }));
    }
  }, [user, navigation]);

  useEffect(() => {
    // Organize fields by section for maintenance form
    const organizedSections = {};
    Object.entries(maintenanceFormData).forEach(([fieldName, fieldData]) => {
      const { section = 'Other' } = fieldData;
      if (!organizedSections[section]) {
        organizedSections[section] = {};
      }
      organizedSections[section][fieldName] = fieldData;
    });
    setMaintenanceSections(organizedSections);
  }, [maintenanceFormData]);

  const handleLocationInputChange = (fieldName, value) => {
    // Store cursor position before state update
    const textareaElement = textareaRefs.current[fieldName];
    const cursorPosition = textareaElement ? {
      start: textareaElement.selectionStart,
      end: textareaElement.selectionEnd
    } : null;

    setLocationFormData(prevData => {
      const newData = { ...prevData };
      newData[fieldName] = {
        ...newData[fieldName],
        default: value
      };

      // if (fieldName === 'client') {
      //   const now = new Date();
      //   const formattedDate = `${String(now.getDate()).padStart(2, '0')}_${String(now.getMonth() + 1).padStart(2, '0')}_${String(now.getFullYear()).slice(-2)}`;

      //   newData["numero_contrat"] = {
      //     ...newData["numero_contrat"],
      //     default: newData["client"].default.replaceAll(' ', '_') + "_" + formattedDate
      //   };
      // }
      if (fieldName === 'numero_contrat') {
        newData["reference_mandat"] = {
          ...newData["reference_mandat"],
          default: newData["numero_contrat"].default.replaceAll('SAUVIE', 'SAU')
        };
      }

      if (fieldName === 'adresse' || fieldName === 'code_postal' || fieldName === 'ville') {
        newData["adresse_installation"] = {
          ...newData["adresse_installation"],
          default: newData["adresse"].default + ", " + newData["code_postal"].default + " " + newData["ville"].default
        };

        newData["lieu_installation"] = {
          ...newData["lieu_installation"],
          default: newData["adresse"].default + ", " + newData["code_postal"].default + " " + newData["ville"].default
        };
      }

      if (fieldName === "adresse_installation") {
        newData["lieu_installation"] = {
          ...newData["lieu_installation"],
          default: newData["adresse_installation"].default
        };
      }

      if (fieldName === "nom_locataire" || fieldName === "qualite_du_signataire_locataire") {
        newData["nom_qualite_signataire"] = {
          ...newData["nom_qualite_signataire"],
          default: (newData["nom_locataire"].default === "") ? newData["qualite_du_signataire_locataire"].default : newData["nom_locataire"].default + " - " + newData["qualite_du_signataire_locataire"].default
        };
      }

      // Handle opposite checkbox behavior for payment type
      if (fieldName === 'paiement_recurrent') {
        newData.paiement_ponctuel = {
          ...newData.paiement_ponctuel,
          default: !value
        };
      } else if (fieldName === 'paiement_ponctuel') {
        newData.paiement_recurrent = {
          ...newData.paiement_recurrent,
          default: !value
        };
      }

      return newData;
    });

    // Restore cursor position after state update
    // if (cursorPosition) {
    //   setTimeout(() => {
    //     textareaElement.selectionStart = cursorPosition.start;
    //     textareaElement.selectionEnd = cursorPosition.end;
    //   }, 0);
    // }
  };

  const generateLocationPDF = async () => {
    try {
      const response = await fetch(locationPdfTemplate);
      const fileBuffer = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(fileBuffer);
      const form = pdfDoc.getForm();

      // Store checkbox states before flattening
      const checkboxStates = {};
      Object.entries(locationFormData).forEach(([fieldName, fieldData]) => {
        if (fieldData.type === 'checkbox') {
          const field = form.getCheckBox(fieldName);
          checkboxStates[fieldName] = {
            isChecked: fieldData.default,
            widget: field.acroField.getWidgets()[0],
            page: fieldData.page + 1 //+1 because there is a page with general conditions (p. 3)
          };
        }
      });

      // Fill all fields based on locationFormData
      Object.entries(locationFormData).forEach(([fieldName, fieldData]) => {
        try {
          let field;
          if (fieldData.type === 'checkbox') {
            field = form.getCheckBox(fieldName);
            if (fieldData.default) {
              field.check();
            } else {
              field.uncheck();
            }
          } else {
            field = form.getTextField(fieldName);
            field.setText(fieldData.default?.toString() || '');

            if (fieldData.same_fields) {
              fieldData.same_fields.forEach((sameFieldName) => {
                const sameField = form.getTextField(sameFieldName);
                sameField.setText(fieldData.default?.toString() || '');
              });
            }
          }
        } catch (error) {
          console.error(`Error filling field ${fieldName}:`, error);
        }
      });

      if (lockFields) {
        form.flatten();

        // Redraw checkboxes after flattening
        Object.entries(checkboxStates).forEach(([fieldName, state]) => {
          const { isChecked, widget } = state;
          const page = pdfDoc.getPages()[state.page];
          const { x, y, width, height } = widget.getRectangle();

          // Draw white background for all checkboxes
          page.drawRectangle({
            x: x,
            y: y,
            width: width,
            height: height,
            color: rgb(1, 1, 1),
            opacity: 1,
          });

          // Draw checkbox border with increased visibility
          page.drawRectangle({
            x: x,
            y: y,
            width: width,
            height: height,
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            opacity: 1,
          });

          if (isChecked) {
            // Draw checkmark with increased visibility
            const lineWidth = 2;
            const padding = 2;

            // First line of checkmark (bottom to middle)
            page.drawLine({
              start: { x: x + padding, y: y + height / 2 },
              end: { x: x + width / 3, y: y + padding },
              thickness: lineWidth,
              color: rgb(0, 0, 0),
              opacity: 1,
            });

            // Second line of checkmark (middle to top)
            page.drawLine({
              start: { x: x + width / 3, y: y + padding },
              end: { x: x + width - padding, y: y + height - padding },
              thickness: lineWidth,
              color: rgb(0, 0, 0),
              opacity: 1,
            });
          }
        });
      }

      const pdfBytes = await pdfDoc.save();
      return pdfBytes;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  };

  const downloadLocationPDF = async () => {
    try {
      const pdfBytes = await generateLocationPDF();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = locationFormData.client.default.length > 0 ? 'Contrat_de_location - ' + locationFormData.client.default + '.pdf' : 'Contrat_de_location.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  const handleLocationPreview = async () => {
    try {
      const pdfBytes = await generateLocationPDF();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setPreviewUrl(url);
      setShowPreview(true);
    } catch (error) {
      console.error('Error previewing PDF:', error);
    }
  };

  const closePreview = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
    setShowPreview(false);
  };

  const getLocationPlaceholder = (fieldName) => {
    const placeholders = {
      // Page 0
      client: 'Nom du client',
      reference_dossier: 'Référence du dossier',

      // Page 1 - RENSEIGNEMENTS RELATIFS AU LOCATAIRE
      numero_contrat: 'Numéro du contrat',
      nom_raison_sociale: 'Nom ou raison sociale',
      adresse: 'Adresse complète',
      code_postal: 'Code postal',
      ville: 'Ville',
      forme_juridique: 'Forme juridique (SARL, SAS...)',
      siren: 'Numéro SIREN',
      telephone: 'Numéro de téléphone',
      email: 'Adresse email',

      // Page 1 - DESCRIPTIF DE L'ÉQUIPEMENT
      descriptif_equipement: 'Description détaillée de l\'équipement',
      adresse_installation: 'Adresse d\'installation',
      adresse_facturation: 'Adresse de facturation',
      fournisseur: 'Nom du fournisseur',

      // Page 1 - CONDITIONS FINANCIÈRES
      duree_location: 'Durée de location (en mois)',
      nombre_loyer: 'Nombre de loyers',
      montant_ht_chaque_loyer: 'Montant HT de chaque loyer',
      periodicite_loyers: 'Périodicité des loyers',
      fait_en_3_exemplaires_a: 'Fait à (ville)',
      fait_en_3_exemplaires_le: 'Fait le (date)',

      // Page 1 - Pour le locataire
      nom_locataire: 'Nom du locataire',
      qualite_du_signataire_locataire: 'Qualité du signataire',

      // Page 2 - PROCÈS-VERBAL
      descriptif_equipement_2: 'Description détaillée de l\'équipement',
      locataire: 'Nom du locataire',
      lieu_installation: 'Lieu d\'installation',
      date: 'Date',
      nom_locataire_2: 'Nom du locataire',
      qualite_du_signataire_locataire_2: 'Qualité du signataire',
      fait_a: 'Fait à (ville)',

      // Page 3 - SEPA
      reference_mandat: 'Référence unique du mandat',
      debiteur_nom: 'Nom du débiteur',
      debiteur_siren: 'SIREN du débiteur',
      debiteur_adresse_rue: 'Adresse complète',
      debiteur_adresse_code_postal: 'Code postal',
      debiteur_adresse_ville: 'Ville',
      debiteur_telephone_fixe: 'Téléphone fixe',
      debiteur_telephone_portable: 'Téléphone portable',
      debiteur_email: 'Email du débiteur',
      debiteur_iban: 'IBAN',
      debiteur_bic: 'BIC',
      creancier_nom: 'Nom du créancier',
      ics: 'Identifiant Créancier SEPA (ICS)',
      paiement_recurrent: 'Paiement Récurrent / Répétitif',
      paiement_ponctuel: 'Paiement Ponctuel',
      signe_a: 'Signé à (ville)',
      signe_le: 'Signé le (date)',
      nom_qualite_signataire: 'Nom et qualité du signataire'
    };

    return placeholders[fieldName] || fieldName.replace(/_/g, ' ');
  };

  const renderLocationFieldLabel = (fieldName) => {
    const labels = {
      // Page 0
      client: 'Client',
      reference_dossier: 'Référence Dossier',

      // Page 1 - RENSEIGNEMENTS RELATIFS AU LOCATAIRE
      numero_contrat: 'Numéro de Contrat',
      nom_raison_sociale: 'Nom / Raison Sociale',
      adresse: 'Adresse',
      code_postal: 'Code Postal',
      ville: 'Ville',
      forme_juridique: 'Forme Juridique',
      siren: 'SIREN',
      telephone: 'Téléphone',
      email: 'Email',

      // Page 1 - DESCRIPTIF DE L'ÉQUIPEMENT
      descriptif_equipement: 'Descriptif de l\'Équipement',
      adresse_installation: 'Adresse d\'Installation',
      adresse_facturation: 'Adresse de Facturation',
      fournisseur: 'Fournisseur',

      // Page 1 - CONDITIONS FINANCIÈRES
      duree_location: 'Durée de Location',
      nombre_loyer: 'Nombre de Loyers',
      montant_ht_chaque_loyer: 'Montant HT de Chaque Loyer',
      periodicite_loyers: 'Périodicité des Loyers',
      fait_en_3_exemplaires_a: 'Fait à',
      fait_en_3_exemplaires_le: 'Fait le',

      // Page 1 - Pour le locataire
      nom_locataire: 'Nom du Locataire',
      qualite_du_signataire_locataire: 'Qualité du Signataire',

      // Page 2 - PROCÈS-VERBAL
      descriptif_equipement_2: 'Descriptif de l\'Équipement',
      locataire: 'Locataire',
      lieu_installation: 'Lieu d\'Installation',
      date: 'Date',
      nom_locataire_2: 'Nom du Locataire',
      qualite_du_signataire_locataire_2: 'Qualité du Signataire',
      fait_a: 'Fait à',

      // Page 3 - SEPA
      debiteur_nom: 'Nom du Débiteur',
      debiteur_siren: 'SIREN du Débiteur',
      debiteur_adresse_rue: 'Adresse du Débiteur',
      debiteur_adresse_code_postal: 'Code Postal',
      debiteur_adresse_ville: 'Ville',
      debiteur_telephone_fixe: 'Téléphone Fixe',
      debiteur_telephone_portable: 'Téléphone Portable',
      debiteur_email: 'Email du Débiteur',
      debiteur_iban: 'IBAN',
      debiteur_bic: 'BIC',
      creancier_nom: 'Nom du Créancier',
      ics: 'ICS (Identifiant Créancier SEPA)',
      paiement_recurrent: 'Paiement Récurrent / Répétitif',
      paiement_ponctuel: 'Paiement Ponctuel',
      signe_a: 'Signé à',
      signe_le: 'Signé le',
      nom_qualite_signataire: 'Nom et Qualité du Signataire'
    };

    return labels[fieldName] || fieldName.replace(/_/g, ' ');
  };

  const renderLocationField = (fieldName, fieldData) => {
    switch (fieldData.type) {
      case 'multiline_text':
        return (
          <textarea
            defaultValue={fieldData.default || ''}
            onBlur={(e) => handleLocationInputChange(fieldName, e.target.value)}
            placeholder={getLocationPlaceholder(fieldName)}
            required={fieldData.required}
            className="form-textarea"
          />
        );
      case 'checkbox':
        return (
          <input
            type="checkbox"
            checked={fieldData.default || false}
            onChange={(e) => handleLocationInputChange(fieldName, e.target.checked)}
            required={fieldData.required}
            className="form-checkbox"
          />
        );
      default:
        return (
          <input
            type="text"
            defaultValue={fieldData.default || ''}
            onChange={(e) => handleLocationInputChange(fieldName, e.target.value)}
            placeholder={getLocationPlaceholder(fieldName)}
            required={fieldData.required}
            className="form-input"
          />
        );
    }
  };

  const getMaintenancePlaceholder = (fieldName) => {
    const placeholders = {
      souscripteur: 'Nom du souscripteur (société, établissement)',
      souscripteur_adresse: 'Adresse du souscripteur',
      represente_par: 'Nom et prénom du representant du souscripteur',
      lot: 'Lot(s) concerné(s)',
      date_debut_contrat: 'Date de début du contrat',
      montant_ht: 'Montant HT',
      montant_ttc: 'Montant TTC',
      fait_a: 'Fait à',
      fait_le: 'Fait le',
      signature_souscripteur_fonction: 'Fonction du signataire'
    };
    return placeholders[fieldName] || fieldName.replace(/_/g, ' ');
  };

  const renderMaintenanceFieldLabel = (fieldName) => {
    const labels = {
      souscripteur: 'Souscripteur',
      souscripteur_adresse: 'Adresse du souscripteur',
      represente_par: 'Représente par',
      lot: 'Lot(s) concerné(s)',
      date_debut_contrat: 'Date de début du contrat',
      montant_ht: 'Montant HT',
      montant_ttc: 'Montant TTC',
      fait_a: 'Fait à',
      fait_le: 'Fait le',
      signature_souscripteur_fonction: 'Fonction du signataire'
    };
    return labels[fieldName] || fieldName.replace(/_/g, ' ');
  };

  const handleMaintenanceInputChange = (fieldName, value) => {
    setMaintenanceFormData(prevData => {
      const newData = { ...prevData };
      newData[fieldName] = {
        ...newData[fieldName],
        default: value
      };

      // Handle same fields
      if (newData[fieldName].same_fields) {
        newData[fieldName].same_fields.forEach(sameField => {
          if (newData[sameField]) {
            newData[sameField] = {
              ...newData[sameField],
              default: value
            };
          }
        });
      }

      return newData;
    });
  };

  const renderMaintenanceField = (fieldName, fieldData) => {
    switch (fieldData.type) {
      case 'multiline_text':
        return (
          <textarea
            defaultValue={fieldData.default || ''}
            onChange={(e) => handleMaintenanceInputChange(fieldName, e.target.value)}
            placeholder={getMaintenancePlaceholder(fieldName)}
            required={fieldData.required}
            className="form-textarea"
          />
        );
      case 'checkbox':
        return (
          <input
            type="checkbox"
            checked={fieldData.default || false}
            onChange={(e) => handleMaintenanceInputChange(fieldName, e.target.checked)}
            required={fieldData.required}
            className="form-checkbox"
          />
        );
      default:
        return (
          <input
            type="text"
            defaultValue={fieldData.default || ''}
            onChange={(e) => handleMaintenanceInputChange(fieldName, e.target.value)}
            placeholder={getMaintenancePlaceholder(fieldName)}
            required={fieldData.required}
            className="form-input"
          />
        );
    }
  };

  const downloadMaintenancePDF = async () => {
    try {
      const pdfBytes = await generateMaintenancePDF();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = maintenanceFormData.souscripteur.default.length > 0
        ? 'Contrat_de_maintenance - ' + maintenanceFormData.souscripteur.default + '.pdf'
        : 'Contrat_de_maintenance.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error filling PDF form:', error);
    }
  };

  const generateMaintenancePDF = async () => {
    try {
      const response = await fetch(maintenancePdfTemplate);
      const fileBuffer = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(fileBuffer);
      const form = pdfDoc.getForm();

      // Store checkbox states before flattening
      const checkboxStates = {};
      Object.entries(maintenanceFormData).forEach(([fieldName, fieldData]) => {
        if (fieldData.type === 'checkbox') {
          const field = form.getCheckBox(fieldName);
          checkboxStates[fieldName] = {
            isChecked: fieldData.default,
            widget: field.acroField.getWidgets()[0],
            page: fieldData.page
          };
        }
      });

      // Fill all fields based on maintenanceFormData
      Object.entries(maintenanceFormData).forEach(([fieldName, fieldData]) => {
        try {
          let field;
          if (fieldData.type === 'checkbox') {
            field = form.getCheckBox(fieldName);
            if (fieldData.default) {
              field.check();
            } else {
              field.uncheck();
            }
          } else {
            field = form.getTextField(fieldName);

            if (fieldName === "souscripteur") {
              if (maintenanceFormData["souscripteur_adresse"].default.length > 0) {
                field.setText((fieldData.default?.toString() || '') + " situé " + (maintenanceFormData["souscripteur_adresse"].default || ''));
              } else {
                field.setText((fieldData.default?.toString() || ''));
              }
            } else if (fieldName === "souscripteur_adresse") {
              //Do nothing (cf fieldName === "souscripteur")
            } else if (fieldName === "montant_ht") {
              field.setText((fieldData.default?.toString() || '') + '€ HT');
            } else if (fieldName === "montant_ttc") {
              field.setText((fieldData.default?.toString() || '') + '€ TTC');
            } else {
              field.setText(fieldData.default?.toString() || '');
            }

            if (fieldData.same_fields) {
              fieldData.same_fields.forEach((sameFieldName) => {
                const sameField = form.getTextField(sameFieldName);
                sameField.setText(fieldData.default?.toString() || '');
              });
            }
          }
        } catch (error) {
          console.error(`Error filling field ${fieldName}:`, error);
        }
      });

      if (lockFields) {
        form.flatten();

        // Redraw checkboxes after flattening
        Object.entries(checkboxStates).forEach(([fieldName, state]) => {
          const { isChecked, widget } = state;
          const page = pdfDoc.getPages()[state.page];
          const { x, y, width, height } = widget.getRectangle();

          // Draw white background for all checkboxes
          page.drawRectangle({
            x: x,
            y: y,
            width: width,
            height: height,
            color: rgb(1, 1, 1),
            opacity: 1,
          });

          // Draw checkbox border with increased visibility
          page.drawRectangle({
            x: x,
            y: y,
            width: width,
            height: height,
            borderColor: rgb(0, 0, 0),
            borderWidth: 1,
            opacity: 1,
          });

          if (isChecked) {
            // Draw checkmark with increased visibility
            const lineWidth = 2;
            const padding = 2;

            // First line of checkmark (bottom to middle)
            page.drawLine({
              start: { x: x + padding, y: y + height / 2 },
              end: { x: x + width / 3, y: y + padding },
              thickness: lineWidth,
              color: rgb(0, 0, 0),
              opacity: 1,
            });

            // Second line of checkmark (middle to top)
            page.drawLine({
              start: { x: x + width / 3, y: y + padding },
              end: { x: x + width - padding, y: y + height - padding },
              thickness: lineWidth,
              color: rgb(0, 0, 0),
              opacity: 1,
            });
          }
        });
      }

      const pdfBytes = await pdfDoc.save();
      return pdfBytes;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  };

  const handleMaintenancePreview = async () => {
    try {
      const pdfBytes = await generateMaintenancePDF();
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      console.log(url);
      setPreviewUrl(url);
      setShowPreview(true);
    } catch (error) {
      console.error('Error previewing PDF:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={sauvieLogo} alt="Sauvie Logo" className="logo" />
        {user && (
          <h1>{navigation === 'location' ? 'Contrat de Location' : 'Contrat de Maintenance'}</h1>
        )}
        {user && (
          <button onClick={handleLogout} className="logout-button">
            Se déconnecter
          </button>
        )}
      </header>
      {user ? (
        <div className="app-container">
          <nav className="side-menu">
            <button
              className={`menu-item ${navigation === 'location' ? 'active' : ''}`}
              onClick={() => {
                setNavigation('location');

                // Generate formatted date
                // const now = new Date();
                // const formattedDate = `${String(now.getFullYear()).slice(-2)}${String(now.getMonth() + 1).padStart(2, '0')}`;

                // // Update locationFormData with new numero_contrat
                // setLocationFormData(prevData => ({
                //   ...prevData,
                //   numero_contrat: {
                //     ...prevData.numero_contrat,
                //     default: `SAUVIE-${formattedDate}00`
                //   }
                // }));
              }}
            >
              Contrat de location
            </button>
            <button
              className={`menu-item ${navigation === 'maintenance' ? 'active' : ''}`}
              onClick={() => setNavigation('maintenance')}
            >
              Contrat de maintenance
            </button>
          </nav>
          <main className="App-main">
            {navigation === 'location' ? (
              <>
                <div className="file-controls">
                  <div className="controls-container">
                    <div className="lock-controls">
                      <label className="lock-label">
                        <input
                          type="checkbox"
                          checked={lockFields}
                          onChange={(e) => setLockFields(e.target.checked)}
                        />
                        <span>Verrouiller les champs après remplissage</span>
                      </label>
                    </div>
                    <div className="button-group">
                      <button onClick={handleLocationPreview} className="preview-button">
                        Prévisualiser le PDF
                      </button>
                      <button onClick={downloadLocationPDF} className="fill-button">
                        Télécharger le PDF
                      </button>
                    </div>
                  </div>
                </div>

                {showPreview && (
                  <div className="preview-modal" onClick={closePreview}>
                    <div className="preview-content" onClick={(e) => e.stopPropagation()}>
                      <button onClick={closePreview} className="close-preview">
                        ×
                      </button>
                      <iframe
                        src={previewUrl}
                        title="PDF Preview"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                      />
                    </div>
                  </div>
                )}
                <div className="form-container">
                  <div className="tabs">
                    {Object.keys(sections).map((page) => (
                      <button
                        key={page}
                        className={`tab ${currentPage === Number(page) ? 'active' : ''}`}
                        onClick={() => setCurrentPage(Number(page))}
                      >
                        Page {Number(page) + 1}
                      </button>
                    ))}
                  </div>

                  <div className="form-content">
                    {sections[currentPage] && Object.entries(sections[currentPage]).map(([section, fields]) => (
                      <div key={section} className="form-section">
                        <h3>{section}</h3>
                        <div className="fields-grid">
                          {Object.entries(fields).map(([fieldName, fieldData]) => (
                            <div key={fieldName} className="field">
                              <label>
                                {renderLocationFieldLabel(fieldName)}
                                {fieldData.required && <span className="required">*</span>}
                              </label>
                              {renderLocationField(fieldName, fieldData)}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="navigation-buttons">
                    <button
                      onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
                      disabled={currentPage === 0}
                      className="nav-button"
                    >
                      Précédent
                    </button>
                    {currentPage !== Math.max(...Object.keys(sections).map(Number)) && (
                      <button
                        onClick={() => setCurrentPage(prev => Math.min(Math.max(...Object.keys(sections).map(Number)), prev + 1))}
                        disabled={currentPage === Math.max(...Object.keys(sections).map(Number))}
                        className="nav-button"
                      >
                        Suivant
                      </button>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div>
                <div className="file-controls">
                  <div className="controls-container">
                    <div className="lock-controls">
                      <label className="lock-label">
                        <input
                          type="checkbox"
                          checked={lockFields}
                          onChange={(e) => setLockFields(e.target.checked)}
                        />
                        <span>Verrouiller les champs après remplissage</span>
                      </label>
                    </div>
                    <div className="button-group">
                      <button onClick={handleMaintenancePreview} className="preview-button">
                        Prévisualiser le PDF
                      </button>
                      <button onClick={downloadMaintenancePDF} className="fill-button">
                        Télécharger le PDF
                      </button>
                    </div>
                  </div>
                </div>
                {showPreview && (
                  <div className="preview-modal" onClick={closePreview}>
                    <div className="preview-content" onClick={(e) => e.stopPropagation()}>
                      <button onClick={closePreview} className="close-preview">
                        ×
                      </button>
                      <iframe
                        src={previewUrl}
                        title="PDF Preview"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                      />
                    </div>
                  </div>
                )}
                <div className="form-container">
                  <div className="form-content">
                    {Object.entries(maintenanceSections).map(([section, fields]) => (
                      <div key={section} className="form-section">
                        <h3>{section}</h3>
                        <div className="fields-grid">
                          {Object.entries(fields).map(([fieldName, fieldData]) => (
                            <div key={fieldName} className="field">
                              <label>
                                {renderMaintenanceFieldLabel(fieldName)}
                                {fieldData.required && <span className="required">*</span>}
                              </label>
                              {renderMaintenanceField(fieldName, fieldData)}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      ) : (
        <Login />
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <MainApp />
    </AuthProvider>
  );
}

export default App;
